import React from 'react';
import { checkPasswordStrength } from '../helper';

function PasswordIndicator(props) {
    const levelNames = { 0: 'Empty Password', 1: 'Week', 2: 'Week', 3: 'Medium', 4: 'Strong' };
    const levelClasses = { 0: '', 1: 'text-danger', 2: 'text-danger', 3: 'text-warning', 4: 'text-success' };
    const passwordStrength = checkPasswordStrength(props.value);
    return <small className={'form-text ' + (levelClasses[passwordStrength] || ' text-muted')}><em>{levelNames[passwordStrength]}</em></small>;
}

export default PasswordIndicator;